import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../../../lib/constants';
import { useNotification } from '../../../contexts/NotificationContext';
import { backgroundImages } from '../constants/resetPasswordConstants';

export const useResetPassword = () => {
  const { showNotification } = useNotification();
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === backgroundImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const validatePassword = (password) => {
    const errs = [];
    if (password.length < 8) errs.push('Password must be at least 8 characters long');
    if (!/[A-Z]/.test(password)) errs.push('Password must contain at least one uppercase letter');
    if (!/[a-z]/.test(password)) errs.push('Password must contain at least one lowercase letter');
    if (!/[0-9]/.test(password)) errs.push('Password must contain at least one number');
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) errs.push('Password must contain at least one special character');
    return errs;
  };

  const validate = () => {
    const tempErrors = {};
    if (!password.trim()) {
      tempErrors.password = 'Password is required';
    } else {
      const passwordErrors = validatePassword(password);
      if (passwordErrors.length > 0) tempErrors.password = passwordErrors[0];
    }
    if (!confirmPassword.trim()) {
      tempErrors.confirmPassword = 'Please confirm your password';
    } else if (password !== confirmPassword) {
      tempErrors.confirmPassword = 'Passwords do not match';
    }

    setErrors(tempErrors);
    if (Object.keys(tempErrors).length > 0) {
      showNotification('error', Object.values(tempErrors)[0]);
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    try {
      const res = await axios.post(`${API_BASE_URL}/reset_password/${token}`, { password });
      showNotification('success', res.data.message || 'Password reset successfully.');
      setTimeout(() => navigate('/'), 2000);
    } catch (err) {
      console.error('Reset password error:', err);
      const msg = err.response?.data?.message || 'Failed to reset password. Link may be expired.';
      showNotification('error', msg);
    } finally {
      setLoading(false);
    }
  };

  return {
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    loading,
    showPassword,
    setShowPassword,
    showConfirmPassword,
    setShowConfirmPassword,
    currentImageIndex,
    setCurrentImageIndex,
    errors,
    handleSubmit
  };
};
